import styled from 'styled-components';
import { Children, useState, useEffect } from 'react';
import { RowTable } from '../../../../func/components/Table';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { BasicInfoProps } from '../../data';
import { AFileList, PFileList, ACommonList } from '../../../../sidebar';
import { SButton2 } from '../../../../sidebar/SButton';
import LoanInfoService from '../../../../service/LoanInfo';
const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';

const BasicInfo = ({
  data,
  linkSet,
  caseInfo,
  basicInfo,
  children
}: {
    data: any;
    basicInfo?: any;
    linkSet?: any,
    caseInfo?: any,
    assetDetailLink?: string
    children?: React.ReactNode; 
}) => {
  const { type } = useReportContext();
  const [itemDetailButtonOn, setItemDetailButtonOn] = useState<boolean>(false);
  const [casDetailButtonOn, setCasDetailButtonOn] = useState<boolean>(false);
  const [dateDetailButtonOn, setDateDetailButtonOn] = useState<boolean>(false);

      
    useEffect(() => {
      if (type === 's') {
        return;
      }
      if (caseInfo?.iidx) {
        getData(Number(caseInfo?.iidx));
      }
    }, [type]);

  if (!data) return null;

 if (!data) {
    console.log('BasicInfo: data is null or undefined');
    return null;
  }

   const list = ACommonList(caseInfo, itemDetailButtonOn, casDetailButtonOn, dateDetailButtonOn);

  const targetItem = list.find(item => item.title === '물건상세');

  const rendingData = [
    { key: '물건종별', value: data.category },
    { key: '감정가', value: `${ReportFormatNumber(data.appraisalPrice)}` },
    { key: '최저가', value: `${ReportFormatNumber(data.minimumPrice)}` },
    // { key: '보증금', value: `${ReportFormatNumber(data.deposit)}` },
    {
      key: '토지면적',
      value:
        data.landArea && data.landAreaPyoeng
          ? `${NumberwithComma(
              data.landArea,
            )}m² (${NumberwithComma(data.landAreaPyoeng)}평)`
          : `${data.landArea}`,
    },
    {
      key: '건물면적',
      value:
        data.buildingArea && data.buildingAreaPyoeng
          ? `${NumberwithComma(
              data.buildingArea,
            )}m² (${NumberwithComma(data.buildingAreaPyoeng)}평)`
          : `${data.buildingArea}`,
    },
    { key: '매각물건', value: data.saleItem },
    { key: '소유자', value: data.owner },
  ];
  const PAuctionRendingData = [
    { key: '처분방식', value: data.saleItem },
    { key: '입찰방식', value: data.bidMethod },
    { key: '자산구분', value: data.assetClass },
    { key: '입찰기간', value: data.biddate },
    { key: '용도', value: data.category },
    { key: '유찰횟수', value: data.bidCount },
    {
      key: '토지면적',
      value:
        data.landArea && data.landAreaPyoeng
          ? `${NumberwithComma(
              data.landArea,
            )}m² (${NumberwithComma(data.landAreaPyoeng)}평)`
          : NumberwithComma(data.landArea),
    },
    {
      key: '건물면적',
      value:
        data.buildingArea && data.buildingAreaPyoeng
          ? `${NumberwithComma(
              data.buildingArea,
            )}m² (${NumberwithComma(data.buildingAreaPyoeng)}평)`
          : '',
    },
    { key: '집행기관', value: data.courtName },
    { key: '담당자정보', value: data.manager },
    { key: '감정가', value: `${ReportFormatNumber(data.appraisalPrice)}` },
    { key: '최저입찰가', value: `${ReportFormatNumber(data.minimumPrice)}` },
  ];

  const RenderData = () => {
    if (type === 'a') {
      return rendingData;
    } else {
      return PAuctionRendingData;
    }
  }; 

   const getData = async (iidx: number) => {
      try {
        const res = await LoanInfoService.courtDetail(iidx);
        if (res.data.item_detail.basic_info.case_no !== null) {
          setItemDetailButtonOn(true);
        }
        if (res.data.case_detail.basic_info.case_no !== null) {
          setCasDetailButtonOn(true);
        }
        if (res.data.date_list !== null) {
          setDateDetailButtonOn(true);
        }
      } catch (e) {
        console.log(e);
      }
  };

 const handleClick = () => {
   if (caseInfo?.iidx) {
        console.log('테스트',basicInfo.manager);
    window.open(
       `/itemDetail?iidx=${caseInfo.iidx}`
    );
  }
  };


   return (
    <Container id="물건기본정보">
      <TitleBox>
        <div>물건 기본정보</div>
        {targetItem&&targetItem.link && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
              cursor: 'pointer',
              color: targetItem&&targetItem.color,
            }}
            onClick={() => {
             if (targetItem?.link) {
            window.open(targetItem.link, '_blank');
            }
            }}
           >
             <img src={attachmentIcon} alt="" />
            {/* 아이콘은 따로 관리 필요 */}
            <SButton2
              content={targetItem&&targetItem.title}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '14px',
                fontWeight: '500',
                color: '#008AFF',
                padding: 0,
              }}
            />
          </div>
        )}
      </TitleBox>
      <RowTable data={RenderData()} titleWidth={110} />
    </Container>
  );
};

export default BasicInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const AttachButton = styled.div`
  
`

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AttachBox = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
`;